<template>
  <b-card no-body>
    <b-card-body>
      <h4 class="mb-1">
        {{ title }}
      </h4>

      <text-line :title="t('Name Surname')" :value="data.name" align-items="align-items-start" />
      <text-line
        v-if="data.attention_name"
        :title="t('Contact Person')"
        :value="data.attention_name"
        align-items="align-items-start"
      />
      <text-line :title="t('Address')" :value="data.address" align-items="align-items-start" />
      <text-line
        :title="t('District, City, Country')"
        :value="getLocation"
        align-items="align-items-start"
      />
      <text-line
        :title="t('Postal Code')"
        :value="data.postal_code"
        align-items="align-items-start"
      />
      <text-line :title="t('Phone')" :value="data.phone" align-items="align-items-start" />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import TextLine from '@/components/TextLine.vue';

export default {
  components: {
    TextLine,

    BCard,
    BCardBody
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    getLocation() {
      const parts = [this.data.city, this.data.state, this.data.country]
        .map(part => (part ? String(part).trim() : ''))
        .filter(part => part.length > 0);

      return parts.length > 0 ? parts.join(' / ') : '-';
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
